import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiService from "../services/api.service";
import { Alert } from "react-bootstrap";
import "./userList.css";

const EventView = () => {
  const { id } = useParams();
  const [event, setEvent] = useState({});
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const getEventDetails = async () => {
      setLoading(true);
      try {
        const eventResponse = await apiService.getEvent(id);
        setEvent(eventResponse.data || {});
        const usersResponse = await apiService.getEventAttendance(id);
        setUsers(usersResponse.data || []);
      } catch (err) {
        console.error(err);
        setError("Impossibile caricare i dettagli dell'evento.");
      } finally {
        setLoading(false);
      }
    };
    getEventDetails();
  }, [id]);

  const formatEntrata = (value) => {
    if (!value) return "";
    try {
      const normalized = value.replace(".", ":").replace(".", ":");
      const date = new Date(normalized.replace(/\//g, "-"));
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleString("it-IT");
    } catch {
      return value;
    }
  };

  return (
    <div className="users-page">
      <div className="users-card">
        <div className="users-header">
          <h1 className="users-title">Informazioni evento</h1>
          <span className="users-count">{users.length} partecipanti</span>
        </div>

        {loading && <p className="users-loading">Caricamento...</p>}
        {error && <Alert variant="danger">{error}</Alert>}

        {!loading && !error && (
          <>
            <p><strong>Nome:</strong> {event.name}</p>
            <p><strong>Descrizione:</strong> {event.description}</p>

            {users.length === 0 ? (
              <Alert variant="info">Nessuna presenza registrata.</Alert>
            ) : (
              <div className="users-table">
                <div className="users-table-head">
                  <span>Username</span>
                  <span>Nome</span>
                  <span>Cognome</span>
                  <span>Entrata</span>
                  <span aria-hidden="true" />
                </div>
                {users.map((user) => (
                  <div className="users-table-row" key={`${user.username}-${user.entrata}`}>
                    <div className="users-field">
                      <span className="users-field-label">Username</span>
                      <p className="users-field-value">{user.username}</p>
                    </div>
                    <div className="users-field">
                      <span className="users-field-label">Nome</span>
                      <p className="users-field-value">{user.first_name}</p>
                    </div>
                    <div className="users-field">
                      <span className="users-field-label">Cognome</span>
                      <p className="users-field-value">{user.last_name}</p>
                    </div>
                    <div className="users-field">
                      <span className="users-field-label">Entrata</span>
                      <p className="users-field-value">{formatEntrata(user.entrata)}</p>
                    </div>
                    <div className="users-actions" />
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default EventView;
